import StopCovid from "./stop-covid";
export default StopCovid;
